export const SEARCH_COMPANIES_DATA = "SEARCH_COMPANIES_DATA";

export const actionTypes = {
    OPEN_UPGRADE_FORM: 'OPEN_UPGRADE_FORM',
    CLOSE_UPGRADE_FORM: 'CLOSE_UPGRADE_FORM'
  };
  